import styled from 'styled-components';

import { appColors } from '../../config/colors';
import { device } from '../../config/sizes';

export const CommentContainer = styled.div`
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(1, 1fr);
  margin-top: 1em;
  margin-bottom: 4em;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const CommentBox = styled.div`
  display: inline-block;
  font-size: 0.8em;
  text-align: left;
  padding: 10px;
  border: 0.1px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
  background-color: ${appColors.backgroundSecondary};

  @media ${device.tablet} {
    font-size: 0.6em;
    grid-template-columns: repeat(2, 1fr);
  }

  .timeStamp {
    font-weight: bold;
    margin: 0;
    margin-bottom: 0.5em;
  }

  .comment {
    margin: 0;
  }
`;

export const CommentTesterWrapper = styled.div`
  display: block;
  width: 100%;
  padding: 2em;
  margin-top: 2em;
  margin-bottom: 4em;
  border: 0.1px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
  background-color: ${appColors.backgroundSecondary}; ;
`;

export const CommentTesterForm = styled.form``;

export const CommentTesterTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 1em;
  font-size: 1rem;
  padding: 0.5em;
  border: 1px solid ${appColors.border};
  border-left: 3px solid ${appColors.outline};
  resize: vertical;
`;

export const CommentTesterButton = styled.input`
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5em;
  margin-left: auto;
  color: ${appColors.buttonFont};
  background-color: ${appColors.buttonBackground};
  border-top: 2px solid ${appColors.border};
  border-right: 2px solid ${appColors.shadow};
  border-bottom: 2px solid ${appColors.shadow};
  border-left: 2px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
`;

export const CommentTesterResponseWrapper = styled.div`
  display: flex;
`;

export const CommentTesterResponse = styled.div<{ type?: string }>`
  color: white;
  border-radius: 0.25em;
  padding: 0.5em;
  font-size: 0.75em;
  margin-right: 2em;
  background-color: ${({ type }) =>
    type === 'mention' ? appColors.tagSuccess : appColors.tagNeutral};
`;
